import {
  ClipboardCheck, Gauge, Wrench, Cpu, SprayCan, Shield,
  Snowflake, FileSearch, Droplets,
} from "lucide-react";
import { trackEvent } from "@/utils/tracking";

// Order matches translations.services.items (S/01 → S/09)
const ICONS = [
  Wrench,         // S/01 Mecanică & Revizii
  Cpu,            // S/02 Diagnoză computerizată
  SprayCan,       // S/03 Tinichigerie & Vopsitorie
  Shield,         // S/04 Parbrize Pilkington
  Snowflake,      // S/05 Climatizare auto
  FileSearch,     // S/06 Constatări daune
  Droplets,       // S/07 Uleiuri & consultanță
  ClipboardCheck, // S/08 ITP Auto & Camioane
  Gauge,          // S/09 Verificare Tahograf
];

export default function Services({ t }) {
  const getServiceHref = (serviceCode) => {
    if (serviceCode === "S/01") return "/mecanica-revizii";
    if (serviceCode === "S/02") return "/diagnoza-computerizata";
    if (serviceCode === "S/03") return "/vopsitorie-auto";
    if (serviceCode === "S/04") return "/parbrize-pilkington";
    if (serviceCode === "S/05") return "/climatizare-auto";
    if (serviceCode === "S/06") return "/constatari-daune";
    if (serviceCode === "S/07") return "/uleiuri-consultanta";
    if (serviceCode === "S/08") return "/itp-auto-camioane";
    if (serviceCode === "S/09") return "/verificare-tahograf";
    return null;
  };

  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-[#f7f8fa] border-b border-[#e2e6ec]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#e3191b] mb-4">
              {t.services.eyebrow}
            </div>
            <h2 className="font-[Barlow_Condensed] font-bold uppercase tracking-tight text-[#0b1220] text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-3xl">
              {t.services.title}
            </h2>
          </div>
          <p className="text-slate-600 max-w-md text-sm leading-relaxed">
            {t.services.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-px bg-[#e2e6ec] border border-[#e2e6ec]">
          {t.services.items.map((it, i) => {
            const Icon = ICONS[i] || Wrench;
            const href = getServiceHref(it.code);
            const Wrapper = href ? "a" : "div";
            const wrapperProps = href
              ? {
                href,
                className: "block h-full",
                onClick: () =>
                  trackEvent("service_card_click", {
                    service_code: it.code,
                    service_title: it.title,
                    target_path: href,
                  }),
              }
              : { className: "h-full" };

            return (
              <Wrapper key={i} data-testid={`service-card-${i}`} {...wrapperProps}>
                <div
                  className={`group bg-white hover:bg-[#eaf0fb] p-6 lg:p-7 transition-colors duration-200 border-t-2 border-t-transparent hover:border-t-[#e3191b] h-full flex flex-col ${
                    href ? "cursor-pointer" : "cursor-default"
                  }`}
                >
                  <div className="flex items-start justify-between mb-6">
                    <div className="w-11 h-11 bg-[#eaf0fb] group-hover:bg-[#0b378c] flex items-center justify-center transition-colors">
                      <Icon
                        className="w-5 h-5 text-[#0b378c] group-hover:text-white transition-colors"
                        strokeWidth={1.75}
                      />
                    </div>
                    <span className="font-mono text-[10px] tracking-[0.2em] text-slate-400">
                      {it.code}
                    </span>
                  </div>
                  <h3 className="font-[Barlow_Condensed] font-bold uppercase text-xl text-[#0b1220] tracking-tight leading-tight">
                    {it.title}
                  </h3>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed">
                    {it.desc}
                  </p>
                  <div className={`mt-4 font-mono text-xs uppercase tracking-wider ${href ? "text-[#0b378c]" : "text-transparent select-none"}`}>
                    {href ? t.services.detailsCta : "\u00A0"}
                  </div>
                </div>
              </Wrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
}
